var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 128,
    viewBox: "0 0 134 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7207 63.9962C57.569 63.9962 49.7345 60.8943 43.2174 54.6906C36.7002 48.4869 33.4417 41.0292 33.4417 32.3177C33.4417 23.6061 36.7002 16.1484 43.2174 9.94472C49.7345 3.74101 57.569 0.63916 66.7207 0.63916C75.8725 0.63916 83.7069 3.74101 90.2241 9.94472C96.7412 16.1484 99.9998 23.6061 99.9998 32.3177C99.9998 41.0292 96.7412 48.4869 90.2241 54.6906C83.7069 60.8943 75.8725 63.9962 66.7207 63.9962ZM0.162598 127.353V105.178C0.162598 100.69 1.37729 96.5643 3.80666 92.7998C6.23603 89.0354 9.45855 86.1658 13.4742 84.1912C22.0713 80.0994 30.8071 77.0292 39.6815 74.9807C48.5559 72.9321 57.569 71.9105 66.7207 71.9158C75.8725 71.9158 84.8856 72.94 93.76 74.9886C102.634 77.0371 111.37 80.1047 119.967 84.1912C123.988 86.1711 127.214 89.0433 129.643 92.8077C132.072 96.5722 133.284 100.696 133.279 105.178V127.353H0.162598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.67cb9e2e5f9ca28c48e00eb2a727e633.svg";
export { ForwardRef as ReactComponent };